import { Card, CardString } from 'pokersolver'

export const getCardString = (card: Card | CardString) => {
  let result
  if (typeof card === 'string') {
    result = card
  } else if ('suit' in card && typeof card.suit === 'string') {
    result = `${card.value}${card.suit}`
  } else {
    result = (card as Card).toString()
  }
  return result.replace('10', 'T') as CardString
}

export type PlayingStyle = 'Tight-Aggressive' | 'Loose-Aggressive' | 'Loose-Passive' | 'Tight-Passive' | 'Balanced Play'

export const calculatePlayingStyle = (preFlopFoldPercentage: number, winAtShowdownPercentage: number): PlayingStyle => {
  if (preFlopFoldPercentage >= 66.66 && winAtShowdownPercentage >= 66.66) {
    return 'Tight-Aggressive'
  }
  if (preFlopFoldPercentage <= 33.33 && winAtShowdownPercentage >= 66.66) {
    return 'Loose-Aggressive'
  }
  if (preFlopFoldPercentage <= 33.33 && winAtShowdownPercentage <= 33.33) {
    return 'Loose-Passive'
  }
  if (preFlopFoldPercentage >= 66.66 && winAtShowdownPercentage <= 33.33) {
    return 'Tight-Passive'
  }
  if (
    preFlopFoldPercentage > 33.33 &&
    preFlopFoldPercentage < 66.66 &&
    winAtShowdownPercentage >= 33.33 &&
    winAtShowdownPercentage <= 66.66
  ) {
    return 'Balanced Play'
  }
  return 'Balanced Play' // kept in a different else clause as the default. For the moment, we use Balanced play as the fallback
}
